import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { useAuthToken, useAuthUser } from "./api/adminApi";
import AppLayout from "./components/AppLayout/AppLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import AnalyticsPage from "./pages/Analytics/AnalyticsPage";
import SiteInsightsPage from "./pages/Analytics/SiteInsightsPage";
import ConversationHistoryPage from "./pages/Conversations/ConversationHistoryPage";
import TicketsPage from "./pages/Tickets/TicketsPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import LoginPage from "./pages/Login/LoginPage";
import SettingsPage from "./pages/Settings/SettingsPage";
import AiSettingsPage from "./pages/AiSettings/AiSettingsPage";
import FlowPage from "./pages/Flow/FlowPage";
import UsersPage from "./pages/Users/UsersPage";
import { canAccessPage, firstAllowedPath } from "./permissions";

function App() {
  const token = useAuthToken();
  const user = useAuthUser();
  const administrator = user.role === "admin" || user.isSuperAdmin;
  const accessDenied = <div className="module-page"><div className="notice notice--error" role="alert">You do not have access to this page. Ask a site administrator to update your page access.</div></div>;
  return <Router><Routes>
    <Route path="/login" element={token ? <Navigate to={firstAllowedPath(user)} replace /> : <LoginPage />} />
    <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
      <Route path="/dashboard" element={canAccessPage(user, "dashboard") ? <DashboardPage /> : accessDenied} />
      <Route path="/tickets" element={canAccessPage(user, "tickets") ? <TicketsPage /> : accessDenied} />
      <Route path="/conversations" element={canAccessPage(user, "conversations") ? <ConversationHistoryPage /> : accessDenied} />
      <Route path="/analytics" element={canAccessPage(user, "analytics") ? <AnalyticsPage /> : accessDenied} />
      <Route path="/analytics/site-insights" element={canAccessPage(user, "analytics") ? <SiteInsightsPage /> : accessDenied} />
      <Route path="/settings" element={administrator ? <SettingsPage /> : accessDenied} />
      <Route path="/ai-settings" element={administrator ? <AiSettingsPage /> : accessDenied} />
      <Route path="/flow" element={administrator ? <FlowPage /> : accessDenied} />
      <Route path="/users" element={administrator ? <UsersPage /> : accessDenied} />
      <Route path="/no-access" element={accessDenied} />
    </Route>
    <Route path="*" element={<Navigate to={token ? firstAllowedPath(user) : "/login"} replace />} />
  </Routes></Router>;
}

export default App;
